const stepsData = [
    {
        title: "시험 정보 확인",
        details: [
            "시험 상세 정보 확인",
            "시험 일정 확인"
        ]
    },
    {
        title: "레벨 테스트",
        details: [
            "시험 유형 확인",
            "무료 테스트로 레벨 테스트"
        ]
    },
    {
        title: "접수 및 결제",
        details: [
            "원하는 시험 응시",
            <>결제 진행 <a href="#" className={`underline  text-lg`}>결제 방법 보러가기</a></>
        ]
    },
    {
        title: "시험 응시",
        details: [
            "시험 일정에 맞춰 시험 응시",
            "테스트 진행"
        ]
    },
    {
        title: "시험 결과 확인",
        details: [
            "시험 결과 일정 확인",
            "시험 결과 확인"
        ]
    },
    {
        title: "자격증 신청",
        details: [
            "해당 자격증 신청",
            "자격증 출력 또는 배송"
        ]
    }
];

export const ProcessSection = () => {
    return (
        <section className={`py-20 px-32 flex-col bg-gray-50`}>
            <h1 className={`text-3xl mb-12 `}>AITe 번역 시험 프로세스</h1>
            <div className={`flex justify-around`}>
                {stepsData.map((step, index) => (
                    <div key={index} >
                        <img src="/images/home/pencil.png" alt="" className={`w-[40px] mb-2`}/>
                        <h2 className="text-xl text-blue-600  ">{step.title}</h2>
                        <ul className=" ">
                            {step.details.map((detail, idx) => (
                                <li key={idx} className="text-lg">{detail}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
};
